import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const SortingControls = ({ sortBy, sortOrder, onSortChange, viewMode, onViewModeChange, resultCount }) => {
  const sortOptions = [
    { value: 'name', label: 'Nom (A-Z)' },
    { value: 'city', label: 'Ville' },
    { value: 'fees', label: 'Frais de scolarité' },
    { value: 'threshold', label: 'Seuil d\'admission' },
    { value: 'difficulty', label: 'Difficulté d\'admission' },
    { value: 'popularity', label: 'Popularité' },
    { value: 'recent', label: 'Récemment ajouté' }
  ];

  const handleSortChange = (newSortBy) => {
    if (newSortBy === sortBy) {
      // Toggle order if same field
      onSortChange(sortBy, sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      // New field, default to ascending
      onSortChange(newSortBy, 'asc');
    }
  };

  return (
    <div className="flex items-center justify-between mb-6">
      {/* Results Count */}
      <div className="flex items-center space-x-4">
        <p className="text-sm text-muted-foreground">
          <span className="font-medium text-foreground">{resultCount}</span> établissements trouvés
        </p>
      </div>

      {/* Controls */}
      <div className="flex items-center space-x-4">
        {/* Sort Controls */}
        <div className="flex items-center space-x-2">
          <span className="text-sm text-muted-foreground hidden sm:block">Trier par:</span>
          <Select
            options={sortOptions}
            value={sortBy}
            onChange={handleSortChange}
            className="w-48"
          />
          <Button
            variant="outline"
            size="icon"
            onClick={() => onSortChange(sortBy, sortOrder === 'asc' ? 'desc' : 'asc')}
            title={`Tri ${sortOrder === 'asc' ? 'croissant' : 'décroissant'}`}
          >
            <Icon 
              name={sortOrder === 'asc' ? 'ArrowUp' : 'ArrowDown'} 
              size={16} 
            />
          </Button>
        </div>

        {/* View Mode Toggle */}
        <div className="hidden lg:flex items-center border border-border rounded-lg">
          <button
            onClick={() => onViewModeChange('grid')}
            className={`p-2 rounded-l-lg transition-smooth ${
              viewMode === 'grid' ?'bg-primary text-primary-foreground' :'text-muted-foreground hover:text-foreground hover:bg-muted'
            }`}
            title="Vue grille"
          >
            <Icon name="Grid3X3" size={16} />
          </button>
          <button
            onClick={() => onViewModeChange('list')}
            className={`p-2 rounded-r-lg transition-smooth ${
              viewMode === 'list' ?'bg-primary text-primary-foreground' :'text-muted-foreground hover:text-foreground hover:bg-muted'
            }`}
            title="Vue liste"
          >
            <Icon name="List" size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SortingControls;